import { SSOProfile } from "@10x/sso/SSOProfile";
import Strings from "@my-dld/assets/strings";
import { DateUtil, ServerDate, StringUtil } from "@eres/core";
import { getAppServices } from "@10x/coreapp";
import { ServiceCard } from "@my-dld/components/ServiceContainer";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { IStore } from "@my-dld/reducers/store";
import { GridView } from "./UIUtils";
import _ from "lodash";

export function openDocument( url: string, title: string ) {
	const myWidth = window.outerWidth;
	const myHeight = window.outerHeight;
	const left = ( window.screen.width - myWidth ) / 2;
	const top = ( window.screen.height - myHeight ) / 4;
	const features = "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + myWidth + ", height=" + myHeight + ", top=" + top + ", left=" + left;
	return window.open( url, title, features );
}

export function openPayment( url: string ) {
	const myWidth = window.outerWidth;
	const myHeight = window.outerHeight;
	const left = ( window.screen.width - myWidth ) / 2;
	const top = ( window.screen.height - myHeight ) / 4;
	const features = "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + myWidth + ", height=" + myHeight + ", top=" + top + ", left=" + left;
	return window.open( url, "Payment", features );
}

export function later<T>( delay: number, value: T ): Promise<T> {
	return new Promise( resolve => setTimeout( resolve, delay, value ) );
}


String.prototype.formatUnicorn = String.prototype.formatUnicorn ||
	function () {
		"use strict";
		// @ts-ignore
		var str = ( this as any ).toString();
		if ( arguments.length ) {
			var t = typeof arguments[ 0 ];
			var key;
			var args = ( "string" === t || "number" === t ) ?
				Array.prototype.slice.call( arguments )
				: arguments[ 0 ];

			for ( key in args ) {
				str = str.replace( new RegExp( "\\{" + key + "\\}", "gi" ), args[ key ] );
			}
		}

		return str;
	};

export function isUaePassEnabled() {
	return window && window.AppInfo && window.AppInfo.enableUaePass;
}

export function isSSOUser() {
	return SSOProfile.getProfile() != null;
}

export function isUaePassUser() {
	const state = getAppServices().storeService.getStore().getState();
	return state?.User?.isUaePassUser === true;
}

export function StringsWithPrefix( prefix: string ) {
	const results: string[] = [];
	if ( Strings && typeof Strings === "object" ) {
		const keys = Object.keys( Strings );
		for ( const key of keys ) {
			if ( key.startsWith( prefix ) ) {
				results.push( Strings[ key ] );
			}
		}
	}
	return results;
}

export function formatAppDate( input: Date | ServerDate | undefined, forceLocale = "en" ): string {
	if ( input == undefined ) return "";
	if ( !( input instanceof Date ) )
		input = input.asDate();
	return DateUtil.formatDate( input, "DD-MM-YYYY", forceLocale );

}

export function showOnMap( lat: number, lng: number ) {
	const url = "https://maps.google.com/?q=" + lat + "," + lng;
	window.open( url );
}

export function isShareSupport() {
	let shareVar: any = window.navigator;
	return ( shareVar !== undefined && shareVar.share !== undefined );
}

export function shareContent( title: string, info: string, url?: string ) {
	let shareVar: any = window.navigator;
	if ( shareVar && shareVar.share ) {
		shareVar.share( {
			title: title,
			text: info,
			url: url,
		} ).then( () => {
			console.log( "Share is Successful" );
		} ).catch( ( error: any ) => {
			console.log( "Error in Share", error );
		} );
	}
}

export function isFileShareSupport() {
	let shareVar: any = window.navigator;
	return ( shareVar !== undefined && shareVar.canShare !== undefined );
}

export function shareFiles( title: string, files: File[], info?: string ) {
	let shareVar: any = window.navigator;
	if ( shareVar && shareVar.share ) {
		shareVar.share( {
			title: title,
			text: info,
			files: files,
		} ).then( () => {
			console.log( "Share is Successful" );
		} ).catch( ( error: any ) => {
			console.log( "Error in Share", error );
		} );
	}
}

export function openBinaryAsDocument( binary: string, title: string, type: string ) {
	const binaryString = window.atob( binary );
	const len = binaryString.length;
	const bytes = new Uint8Array( len );
	for ( let i = 0; i < len; ++i ) {
		bytes[ i ] = binaryString.charCodeAt( i );
	}
	const file = new Blob( [ bytes ], { type: type } );
	const fileURL = URL.createObjectURL( file );
	openDocument( fileURL, title );
}

export function UaePassUserFilter( service: ServiceCard, index: number, array: ServiceCard[] ): boolean {
	if ( !isUaePassUser() ) {
		return !( service.requireUaePassUser === true );
	}
	return true;
}

export const useAppSelector: TypedUseSelectorHook<IStore> = useSelector;

export function useViewModeType() {
	const viewType = useAppSelector( x => x.User.viewType );
	if ( viewType ) return viewType;
	return GridView;
}


const EXCLUDED_WORDS = [ "PJSC", "P.J.S.C", "(PJSC)", "(P.J.S.C)", "P.S.C", "LLC", "L.L.C", "(L.L.C)", "FZ-LLC", "FZC", "(FZC)" ];

export function FixCapName( input?: string ) {
	if ( StringUtil.isEmptyStringOrNull( input ) ) return "";
	return _.split( input!, /\s/ ).map( _.capitalize ).join( " " );
}

export function FixCapNameX( input: string ) {
	if ( input ) {
		const words = _.split( input, /\s/ );
		let r = "";
		for ( const word of words ) {
			if ( EXCLUDED_WORDS.some( w => w === word ) ) {
				r = `${ r } ${ word }`;
			} else {
				r = `${ r } ${ FixCapName( word ) }`;
			}
		}
		return r.trim();
	}
	return input;
}

export function isSSPProfileUpdateOTPDisabled() {
	return window && window.AppInfo && window.AppInfo.ssoDisableProfileUpdateOTP;
}

export function featureGateCheck (featureId : string) : boolean {
	return (window.AppInfo.featureGate && window.AppInfo.featureGate[featureId]) ? window.AppInfo.featureGate[featureId] : false;
}
